import { DeclareInterestDialog } from "src/components/modals/declare-interest-dialog/declare-interest-dialog";
import { Button, type ButtonProps } from "src/components-mui/base/button/button";

const DECLARE_INTEREST_BUTTON_TEST_ID = "declare-interest-button";

interface IProps extends ButtonProps {
    wikifolioId: string;
}

export const DeclareInterestButton = ({ wikifolioId, children, ...buttonProps }: IProps) => {
    return (
        <DeclareInterestDialog wikifolioId={wikifolioId}>
            {({ handleOnClick, isLoading }) => (
                <Button onClick={handleOnClick} {...buttonProps} loading={isLoading} data-test-id={DECLARE_INTEREST_BUTTON_TEST_ID}>
                    {children}
                </Button>
            )}
        </DeclareInterestDialog>
    );
};
